import Rellax from "rellax";

export default class ParallaxController {

    constructor() {
        this.init();
    }

    init() {

        let parallaxEl = document.querySelectorAll(".js-parallax");

        if (parallaxEl.length < 1) {
            return;
        }

        let rellax = new Rellax(".js-parallax", {
            center: true,
        });

    }

}
